<form [formGroup]="inspectionForm" (ngSubmit)="onSubmit()" class="p-6 bg-white rounded-lg shadow-md">
    <!-- Basic Planning Fields -->
    <div class="grid grid-cols-12 gap-6">
        <div class="col-span-6">
            <mat-label>Inspection ID</mat-label>

            <mat-form-field appearance="outline">
                <input matInput formControlName="inspection_id" />
            </mat-form-field>

        </div>

        <div class="col-span-6">
            <mat-label>Project Name</mat-label>

            <mat-form-field appearance="outline">
                <input matInput formControlName="project_name" />
            </mat-form-field>
        </div>
        <div class="col-span-6">
            <mat-label>Inspection Date</mat-label>

            <mat-form-field appearance="outline">
                <input matInput [matDatepicker]="inspDate" formControlName="inspection_date" />
                <mat-datepicker-toggle matSuffix [for]="inspDate"></mat-datepicker-toggle>
                <mat-datepicker #inspDate></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-span-6">
            <mat-label>Inspector Name</mat-label>

            <mat-form-field appearance="outline">
                <input matInput formControlName="inspector_name" />
            </mat-form-field>
        </div>
        <div class="col-span-6">
            <mat-label>Inspection Type</mat-label>

            <mat-form-field appearance="outline">
                <input matInput formControlName="inspection_type" />
            </mat-form-field>
        </div>
        <div class="col-span-6">
            <mat-label>Findings Summary</mat-label>

            <mat-form-field appearance="outline">
                <textarea matInput formControlName="findings_summary"></textarea>
            </mat-form-field>
        </div>
        <div class="col-span-6">
            <mat-label>Compliance Status</mat-label>

            <mat-form-field appearance="outline">
                <input matInput formControlName="compliance_status" />
            </mat-form-field>
        </div>
        <div class="col-span-6">
            <mat-label>Corrective Action Plan</mat-label>

            <mat-form-field appearance="outline">
                <textarea matInput formControlName="corrective_action_plan"></textarea>
            </mat-form-field>

        </div>
        <div class="col-span-6">
            <mat-label>Next Inspection Date</mat-label>

            <mat-form-field appearance="outline">
                <input matInput [matDatepicker]="nextDate" formControlName="next_inspection_date" />
                <mat-datepicker-toggle matSuffix [for]="nextDate"></mat-datepicker-toggle>
                <mat-datepicker #nextDate></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-span-6">
            <mat-label>Inspection Report Ref</mat-label>

            <mat-form-field appearance="outline">
                <input matInput formControlName="inspection_report_ref" />
            </mat-form-field>
        </div>

        <!-- Domain Dropdown -->
        <div class="col-span-12">
            <mat-label>Domain</mat-label>

            <mat-form-field appearance="outline" class="col-span-2">
                <mat-select formControlName="domain" (selectionChange)="onDomainChange($event.value)">
                    <mat-option *ngFor="let domain of domainOptions" [value]="domain">
                        {{ domain }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <!-- Dynamic Fields -->

        <ng-container *ngFor="let field of domainFields[selectedDomain]">
            <div class="col-span-4">
                <mat-label>{{ field.label }}</mat-label>

                <mat-form-field appearance="outline" *ngIf="inspectionForm.get(field.key)">
                    <input matInput [type]="field.type" [formControlName]="field.key" />
                </mat-form-field>
            </div>
        </ng-container>

        <div class="col-span-12 mt-2 p-4 border border-slate-200 rounded-lg bg-slate-50">
            <div class="flex items-center justify-between mb-3">
                <h3 class="text-sm font-semibold text-slate-700">LRS corridor (optional)</h3>
                <button mat-stroked-button type="button" (click)="openInspectionOnMap()">Open on map</button>
            </div>
            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-6">
                    <mat-label>Route</mat-label>
                    <mat-form-field appearance="outline" class="w-full">
                        <mat-select formControlName="lrsRouteId">
                            <mat-option [value]="null">None</mat-option>
                            <mat-option *ngFor="let route of lrsRoutes" [value]="route.id">
                                {{ route.route_code }} — {{ route.route_name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-span-3">
                    <mat-label>From km</mat-label>
                    <mat-form-field appearance="outline" class="w-full">
                        <input matInput type="number" step="0.001" formControlName="lrsFromKm" />
                    </mat-form-field>
                </div>
                <div class="col-span-3">
                    <mat-label>To km</mat-label>
                    <mat-form-field appearance="outline" class="w-full">
                        <input matInput type="number" step="0.001" formControlName="lrsToKm" />
                    </mat-form-field>
                </div>
                <div class="col-span-6">
                    <mat-label>Chainage label</mat-label>
                    <mat-form-field appearance="outline" class="w-full">
                        <input matInput formControlName="lrsChainage" placeholder="e.g. NH-44 @ 120+750" />
                    </mat-form-field>
                </div>
            </div>
        </div>

    </div>
    <!-- Submit Button -->
    <div class="col-span-2 flex justify-end mt-4">
        <button mat-raised-button color="primary" type="submit" [disabled]="saving || inspectionForm.invalid">
            {{ recordId ? 'Update' : 'Submit' }}
        </button>
    </div>
</form>